import { GridColDef, GridRenderCellParams, GridValueGetterParams } from '@mui/x-data-grid-pro'
import { colors } from 'src/theme'
import { Typography } from '@mui/material'
import { TeamMember } from 'src/interfaces/team'
import { TableMarketLabels } from 'src/components/team/grid/TableMarketLabels'
import { teamMemberStatusTitles } from './constants'
import { TeamMemberStatusChip } from 'src/components/team/grid/TeamMemberStatusChip'
import { TableLabel } from 'src/components/shared/label/TableLabel'
import { CustomersMinor } from '@shopify/polaris-icons'
import tw from 'twin.macro'
import { TeamMemberActionButton } from 'src/components/team/tables/team-members-table/TeamMemberActionButton'
import { TeamMemberStatus } from './enums'
import { formatFullNameWithEmail, removeUnderscoresAndCapitalize } from 'src/utils/baseUtils'

export const teamMembersBaseColumns: GridColDef<TeamMember>[] = [
  {
    field: 'userName',
    headerName: 'User name',
    flex: 3,
    sortable: true,
    valueGetter: (params: GridValueGetterParams<TeamMember>) =>
      formatFullNameWithEmail(params.row.firstName, params.row.lastName, params.row.email),
    renderCell: (params) => (
      <div>
        <Typography variant="h6" color={colors.BASICS_BLACK}>
          {`${params.row.firstName} ${params.row.lastName}`}
        </Typography>
        <Typography variant="body2" color={colors.SHADES_GREY_400}>
          {params.row.email}
        </Typography>
      </div>
    ),
  },
  {
    field: 'markets',
    headerName: 'Markets',
    flex: 3,
    sortable: false,
    renderCell: (params: GridRenderCellParams<TeamMember>) => (
      <TableMarketLabels markets={params.row.markets} isAllMarkets={params.row.allMarkets} />
    ),
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 1.5,
    sortable: false,
    valueGetter: (params: GridValueGetterParams<TeamMember>) =>
      teamMemberStatusTitles[
        params.row.disabled ? TeamMemberStatus.Deactivated : TeamMemberStatus.Active
      ],
    renderCell: (params: GridRenderCellParams<TeamMember>) => (
      <TeamMemberStatusChip
        status={params.row.disabled ? TeamMemberStatus.Deactivated : TeamMemberStatus.Active}
      />
    ),
  },
  {
    field: 'role',
    headerName: 'Role',
    flex: 2,
    sortable: false,
    valueGetter: (params: GridValueGetterParams<TeamMember>) =>
      removeUnderscoresAndCapitalize(params.row.role),
    renderCell: (params: GridRenderCellParams<TeamMember>) => (
      <TableLabel
        label={params.value}
        beforeIcon={<CustomersMinor width={20} fill={colors.BASICS_BLACK} />}
        className={tw`bg-[#EDEDED] rounded pl-[4px] pr-[8px] pt-0 pb-0`}
        textColor={colors.SHADES_GREY_500}
      />
    ),
  },
]

export const teamMembersActionColumn: GridColDef<TeamMember> = {
  field: 'actions',
  headerName: 'Actions',
  flex: 1,
  sortable: false,
  renderCell: (params) => <TeamMemberActionButton teamMember={params.row} />,
}
